<template>
  <div :id="'acordionP'+ region.id + deporte.id" class="accordion p-1 mb-1" :style="skin.menu_live.country_fondo">
    <div class="accordion-item" :style="skin.menu_live.country_fondo +'border:none'">
      <div class="accordion-header">
        <span :style="skin.menu_live.country_text"></span>
        <button class="accordion-button p-0 text1" :class="(deporte=='1'?'':' collapsed')" :style="skin.menu_live.country_fondo+skin.menu_live.country_text" type="button" data-bs-toggle="collapse" :data-bs-target="'#p'+ region.id + deporte.id" :aria-expanded="(deporte=='1'?'true':'false')" :aria-controls="'p'+ region.id + deporte.id">
          <span :class="'fi fi-'+ country_flag" style="max-width:25px;height:20px"></span>&nbsp;
          <span class="long_text" :style="skin.menu_live.country_text">{{ region.country }} - {{ region.name }}</span>
        </button>
      </div>
      <div :id="'p'+ region.id + deporte.id" class="accordion-collapse" :class="(deporte=='1'?' show':' collapse')" aria-labelledby="headingOne" :data-bs-parent="'#acordionP'+ region.id + deporte.id">
      <div class="accordion-body p-0" :style="skin.menu_live.country_fondo">
        <eventoEncuentroLive
              v-for="(encuentro) in encuentros"
              v-bind:encuentro="encuentro"
              v-bind:Skin="skin"
              v-bind:key="encuentro.id"
              v-bind:translation="translation"
              v-bind:language="language"
              >
        </eventoEncuentroLive> 
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import eventoEncuentroLive from './Evento_encuentro_live.vue';
const flags = require('../../../../assets/countries.json');
export default{
  name:"eventoPais",
  components:{eventoEncuentroLive},
  data(){
    return {
    }
  },
  props:['region','deporte','skin','translation','language'],
  methods:{
    
  },
  computed:{
    country_flag() {
      let flag = []
      flags.countries.forEach(country => {
        if(country.name_es == this.$props.region.country_alias || country.name_en == this.$props.region.country_alias){
          flag.push(country.code.toLowerCase());
        }
      });
      return flag;
    },
    encuentros(){
      let data = [];
      let words_banned = this.$store.getters['getConfig'].SkinConfig.main.hideWords;
      Object.keys(this.$props.region.game).forEach(element => {
        if(this.$props.region.game[element] && this.$props.region.game[element].info && !this.$props.region.game[element].favorite){
          let banned = false;
          words_banned.forEach(word => {
            if(this.$props.region.game[element].team1_name){
              if(this.$props.region.game[element].team1_name.includes(word)){
                banned = true;
              }
            }
            if(this.$props.region.game[element].team2_name){
              if(this.$props.region.game[element].team2_name.includes(word)){
                banned = true;
              }
            }            
          });
          if(!banned && this.$props.region.game[element].info.current_game_state != "notstarted"){
            this.$props.region.game[element]['sport'] = this.$props.deporte??this.$props.region.sport;
            data.push(this.$props.region.game[element]);
          }
        }
      }); 
      return data;
    }
  }
}
</script>
<style scoped>
  .long_text {
      display: -webkit-box;
      max-width: 200px;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
  }
</style>
